import * as ACTION_TYPES from './action-types';

export const setAllAttachments = (data) => {
  return {
    type: ACTION_TYPES.SET_ALL_ATTACHMENTS,
    payload: data
  }

}
